<!-- <div class="card">
    <p-table [value]="vendorList" styleClass="p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="5"
        [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '50rem' }"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[5, 10, 20]">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 4rem;"></th>
                <th pSortableColumn="vendor_code">Vendor Code <p-sortIcon field="vendor_code"></p-sortIcon></th>
                <th pSortableColumn="business_name">Business Name <p-sortIcon field="business_name"></p-sortIcon></th>
                <th pSortableColumn="vendor_classification">Vendor Classification <p-sortIcon field="vendor_classification"></p-sortIcon></th>
                <th pSortableColumn="pan_no">PAN <p-sortIcon field="pan_no"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vendor>
            <tr>
                <td>
                    <button pButton type="button" icon="pi pi-eye" (click)="goToVendorDetails(vendor.vendor_code)" class="p-button-rounded" pTooltip="View Details"></button>
                </td>
                <td>{{ vendor.vendor_code }}</td>
                <td>{{ vendor.business_name }}</td>
                <td>{{ vendor.vendor_classification }}</td>
                <td>{{ vendor.pan_no }}</td>

            </tr>
        </ng-template>
    </p-table>
</div> -->

<div class="card">
    <p-table [value]="vendorList" styleClass="p-treetable-gridlines" [tableStyle]="{ 'min-width': '100rem' }"
         >
        <ng-template pTemplate="header">
            <tr>
                <th ></th>
                <th pSortableColumn="vendor_code">Name</th>
                <th pSortableColumn="vendor_code">Vendor Code</th>
                <th pSortableColumn="business_name">Primary Address</th>
                <!-- <th pSortableColumn="vendor_classification">Vendor Group</th> -->
                <th pSortableColumn="city">City <p-sortIcon field="city"></p-sortIcon></th>
                <th pSortableColumn="state">State <p-sortIcon field="state"></p-sortIcon></th>
                <th pSortableColumn="country">Country <p-sortIcon field="country"></p-sortIcon></th>
                <th pSortableColumn="gstin">GSTIN Number <p-sortIcon field="gstin"></p-sortIcon></th>
            </tr>
            <tr>
                <th></th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="business_name"
                        placeholder="Search"
                        ariaLabel="Filter Name" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="vendor_code"
                        placeholder="Search"
                        ariaLabel="Filter Vendor Code" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="primary_address"
                        placeholder="Search"
                        ariaLabel="Filter Primary Address" />
                </th>
                <!-- <th>
                    <p-columnFilter
                        type="text"
                        field="vendor_group"
                        placeholder="Search by Vendor Group"
                        ariaLabel="Filter Vendor Group" />
                </th> -->
                <th>
                    <p-columnFilter
                        type="text"
                        field="city"
                        placeholder="Search"
                        ariaLabel="Filter City" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="state"
                        placeholder="Search"
                        ariaLabel="Filter State" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="country"
                        placeholder="Search"
                        ariaLabel="Filter Country" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="gstin"
                        placeholder="Search"
                        ariaLabel="Filter GSTIN" />
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vendor>
            <tr>
                <td>
                    <button pButton type="button" icon="pi pi-eye" (click)="goToVendorDetails(vendor.get_user,vendor.status,vendor.business_name)"
                        class="p-button-rounded" pTooltip="View Details"></button>
                </td>
                <td>{{ vendor.business_name }}</td>
                <td>{{ vendor.vendor_code }}</td>
                <td>{{ vendor.address_details.address_title }}</td>
                <!-- <td>{{ vendor.vendor_group }}</td> -->
                <td>{{vendor.address_details.city}}</td>
                <td>{{ getStateLabel(vendor.address_details.state,vendor.address_details.country)}}</td>
                <td>{{ getcountries(vendor.address_details.country)}}</td>
                <td>{{gst}}</td>

            </tr>
        </ng-template>
    </p-table>
</div>
